import React, { forwardRef, useImperativeHandle, useState } from "react";
import Utils from "../../utils/Utils";

interface Props {
  translateText: string;
  onTranslate?: (translatedText: string) => void;
}

export type EmptyTranslateViewRef = {
  hideTranslateResult: () => void;
};
export const EmptyTranslateView = forwardRef<EmptyTranslateViewRef, Props>(
  (props, ref) => {
    const { translateText } = props;

    // Google Translate states
    const [isTranslating, setIsTranslating] = useState(false);
    const [translatedResult, setTranslatedResult] = useState<string>("");
    const [showTranslateResult, setShowTranslateResult] = useState(false);

    useImperativeHandle(ref, () => ({
      hideTranslateResult() {
        setShowTranslateResult(false);
      },
    }));

    /**
     * Handle Google Translate functionality
     */
    const handleGoogleTranslate = async () => {
      if (!translateText.trim()) {
        return;
      }

      setIsTranslating(true);
      setShowTranslateResult(false);

      try {
        const result = await Utils.translateApi(translateText, "bn");
        setIsTranslating(false);
        setTranslatedResult(result.toString());
        setShowTranslateResult(true);
      } catch (error) {
        setIsTranslating(false);
        console.error("Translation error:", error);
      }
    };

    return (
      <div className="no-data-found">
        <div className="no-data-content">
          {/* Translate Icon */}
          <div className="no-data-icon">
            <svg width="74" height="74" viewBox="-15 -15 54 54" fill="none">
              <path
                d="M12.87 15.07l-2.54-2.51.03-.03c1.74-1.94 2.98-4.17 3.71-6.53H17V4h-7V2H8v2H1v1.99h11.17C11.5 7.92 10.44 9.75 9 11.35 8.07 10.32 7.3 9.19 6.69 8h-2c.73 1.63 1.73 3.17 2.98 4.56l-5.09 5.02L4 19l5-5 3.11 3.11.76-2.04zM18.5 10h-2L12 22h2l1.12-3h4.75L21 22h2l-4.5-12zm-2.62 7l1.62-4.33L19.12 17h-3.24z"
                className="translate-icon-fill"
                transform="scale(1.3) translate(-3.6, -3.6)"
              />
              <circle
                cx="12"
                cy="12"
                r="25"
                className="translate-icon-stroke"
                strokeWidth="1"
                fill="none"
                opacity="0.2"
              />
            </svg>
          </div>

          {/* No Results Text */}
          <div className="no-data-text">
            <h3>No results found</h3>
            <p>
              We couldn't find any words matching "
              <strong>{translateText}</strong>"
            </p>
            <p className="suggestion">
              Try searching with different keywords or use Google Translate
              below
            </p>
          </div>

          {/* Translation Section */}
          <div className="translation-section">
            {showTranslateResult && translatedResult ? (
              <div className="translated-result">
                <div className="translated-content">
                  <span className="translated-label">Translation:</span>
                  <p className="translated-text">{translatedResult}</p>
                </div>
              </div>
            ) : (
              <div className="translate-buttons">
                <button
                  onClick={handleGoogleTranslate}
                  disabled={isTranslating}
                  className="translate-btn primary"
                >
                  {isTranslating ? (
                    <>
                      <div className="spinner"></div>
                      Translating...
                    </>
                  ) : (
                    <>
                      <svg
                        width="20"
                        height="20"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <path
                          d="M12.87 15.07l-2.54-2.51.03-.03c1.74-1.94 2.98-4.17 3.71-6.53H17V4h-7V2H8v2H1v1.99h11.17C11.5 7.92 10.44 9.75 9 11.35 8.07 10.32 7.3 9.19 6.69 8h-2c.73 1.63 1.73 3.17 2.98 4.56l-5.09 5.02L4 19l5-5 3.11 3.11.76-2.04zM18.5 10h-2L12 22h2l1.12-3h4.75L21 22h2l-4.5-12zm-2.62 7l1.62-4.33L19.12 17h-3.24z"
                          fill="currentColor"
                        />
                      </svg>
                      Translate with Google
                    </>
                  )}
                </button>
              </div>
            )}

            {/* {error && <div className="error-message">{error}</div>} */}
          </div>
        </div>
      </div>
    );
  }
);

export default EmptyTranslateView;
